import React from 'react'
import { Button } from '@material-ui/core'
import { Link } from 'react-router-dom'

const RouterLinkButton = React.forwardRef(function RouterLinkButton(
  { children, ...props },
  ref,
) {
  return (
    <Button {...props} component={Link} ref={ref}>
      {children}
    </Button>
  )
})

export default RouterLinkButton
